import React, {
    useState,
    useEffect,
} from "react";
import { AddDialog } from "../../Components/AddDialog";
import { Box, Stack, Typography } from "@mui/material";
import { CollapseStateLabel } from "../../App/CollapseButtons";
import { InputName } from "../../Components/Inputs/Input_Name";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { InputSelect1 } from "../../Components/Inputs/Select";
import { InputMoney } from "../../Components/Inputs/Input_Money";
import { ftchPlus, putOptions } from "../../App/Account_urls";
import { InputNumber } from "../../Components/Inputs/Input_Number";
import dayjs from "dayjs";
import { dateDisabled } from "../../Components/Inputs/Dates.jsx";
import { API_ClientQ } from "../../App/api.jsx";
import { errorClear, errorJsonHasErrors, errorSet, errorSetPlus } from "../../Components/Inputs/Input_Fns.jsx";
import { set } from "lodash";


const defClient = {
    First: "",
    Birthdate: "1970-07-01",
    Province: "",
    Employment: 0,
    Expenses: 0,
    ExpensesPost: 0,
    ExpensesSlowGo: 0,
    ExpensesNoGo: 0,
    Cash: 0,
    NonRegistered: 0,
    TFSA: 0,
    RRSP: 0,
    Home: 0,
    HomeMortgage: 0,
    MortgageRate: 0,
    MortgagePayment: 0,
}

const defAll = {
    RunScenario: false,
    Year: new Date().getFullYear() - 1,
    RetireAge: 65,
    AddSpouse: false,
    Client: { ...defClient },
    Spouse: { ...defClient },
}

const defProvinces = [
    "AB",
    "BC",
    "MB",
    "NB",
    "NL",
    "NS",
    "NU",
    "NT",
    "ON",
    "PE",
    "QC",
    "SK",
    "YU"
]


const QuickClient = ({ open, name, form, primary, onError, onChange }) => {
    const [errors, setErrors] = useState({})
    const onChange_any = (n, v) => {
        let nf = {
            ...form,
            [n]: v,
        };
        onChange(nf);
        validation(nf, errors)
        return nf
    };
    const onChange_t = (e) => {
        onChange_any(e.target.name, e.target.value);

    };
    const onChange_list = (e) => {
        let nf = onChange_any(e.target.name, e.target.value);

    };

    const onChange_date = (e) => {
        if (!e.isValid()) {
            errorSetPlus(onError, errors, setErrors, "Birthdate", null, "Invalid Date")
        } else {
            errorSetPlus(onError, errors, setErrors, "Birthdate", null, "")

            let d = e.$y + "-" + (Number(e.$M) + 1).toString() + "-" + e.$D;
            let nf = { ...form, Birthdate: d };

            console.log(nf);
            onChange(nf);
        }
    };

    const validation = (f, e) => {
        let ne = structuredClone(e)

        let err = (f.Province === "") ? "Please select a province" : ""
        ne = set(ne, "Province", err)
        setErrors(ne)
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }
    useEffect(() => {
        validation(form, errors)
    }, [open])

    const myError = (obj, i, err) => {
        errorSetPlus(onError, errors, setErrors, obj, i, err)
    }

    return (
        <Box sx={{ m: 2, p: 2, border: "1px solid grey" }}>
            <Typography id="who" variant="h6" gutterBottom>
                {name}
            </Typography>


            <Stack spacing={4}>
                <InputName
                    label="First Name"
                    name="First"
                    value={form.First}
                    onChange={onChange_t}
                    onError={(e) => myError("First", null, e)}
                    required
                />
                <DesktopDatePicker
                    maxWidth="false"
                    label="Date of Birth"
                    inputFormat="MM/DD/YYYY"
                    name="Birthdate"
                    value={dayjs(form.Birthdate)}
                    //disableFuture
                    shouldDisableDate={dateDisabled}
                    required
                    onChange={onChange_date}
                    slotProps={{ textField: { size: "small" } }}
                />
                <InputSelect1
                    label="Tax Jurisdiction"
                    name="Province"
                    value={form.Province}
                    onChange={onChange_list}
                    minWidth={300}
                    errors={errors}
                    avail={defProvinces}
                />

                <InputMoney
                    xlabel="Gross Employment Income"
                    name="Employment"
                    money={form.Employment}
                    onChange={onChange_t}
                    width={300}
                    tooltip="Enter your yearly base salary/wage, do NOT include matching programs as you can enter that later."
                    onError={(e) => myError("Employment", null, e)}
                />
                <InputMoney
                    xlabel="Expenses"
                    name="Expenses"
                    money={form.Expenses}
                    onChange={onChange_t}
                    width={300}
                    disabled={name === "Spouse"}
                    tooltip="Enter your yearly expenses, do NOT include savings, mortgage or loan payments since you will enter those elsewhere."
                    onError={(e) => myError("Expenses", null, e)}
                />
                <InputMoney
                    xlabel="Post Retirement Expenses"
                    name="ExpensesPost"
                    money={form.ExpensesPost}
                    onChange={onChange_t}
                    width={300}
                    disabled={name === "Spouse"}
                    tooltip="Enter your post retirement yearly expenses, do NOT include savings, mortgage or loan payments since you will enter those elsewhere."
                    onError={(e) => myError("ExpensesPost", null, e)}
                />
                {/* <InputMoney
                    xlabel="Post Retirement Expenses Slow-Go"
                    name="ExpensesPostSlowGo"
                    money={form.ExpensesPostSlowGo}
                    onChange={onChange_t}
                    width={300}
                    disabled={name === "Spouse"}
                    tooltip="Enter your post retirement (Slow-Go 75+) yearly expenses, do NOT include savings, mortgage or loan payments since you will enter those elsewhere."
                    onError={(e) => myError("ExpensesPostSlowGo", null, e)}
                />
                <InputMoney
                    xlabel="Post Retirement Expenses No-Go"
                    name="ExpensesPostNoGo"
                    money={form.ExpensesPostNoGo}
                    onChange={onChange_t}
                    width={300}
                    disabled={name === "Spouse"}
                    tooltip="Enter your post retirement (No-Go 85+) yearly expenses, do NOT include savings, mortgage or loan payments since you will enter those elsewhere."
                    onError={(e) => myError("ExpensesPostNoGo", null, e)}
                /> */}

                <InputMoney
                    xlabel="Cash Savings"
                    name="Cash"
                    money={form.Cash}
                    onChange={onChange_t}
                    width={300}
                    tooltip="Enter your High Interest Savings and Cash balance"
                    onError={(e) => myError("Cash", null, e)}
                />
                <InputMoney
                    xlabel="Non Registered Investments"
                    money={form.NonRegistered}
                    name="NonRegistered"
                    onChange={onChange_t}
                    width={300}
                    tooltip="Enter your non-registered (non-cash) balance"
                    onError={(e) => myError("NonRegistered", null, e)}
                />
                <InputMoney
                    xlabel="TFSA"
                    money={form.TFSA}
                    name="TFSA"
                    onChange={onChange_t}
                    width={300}
                    tooltip="Enter your TFSA balance"
                    onError={(e) => myError("TFSA", null, e)}
                />
                <InputMoney
                    xlabel="RRSP"
                    money={form.RRSP}
                    name="RRSP"
                    onChange={onChange_t}
                    width={300}
                    tooltip="Enter RRSP balance, this would include a spousal RRSP in your name (you can separate that later if you wish)"
                    onError={(e) => myError("RRSP", null, e)}
                />
                {name === "Client" && (
                    <>
                        <InputMoney
                            label="Home"
                            money={form.Home}
                            name="Home"
                            onChange={onChange_t}
                            width={300}

                            tooltip="Enter the market value of your home"
                            onError={(e) => myError("Home", null, e)}
                        />
                        <InputMoney
                            xlabel="Home Mortgage"
                            money={form.HomeMortgage}
                            name="HomeMortgage"
                            onChange={onChange_t}
                            width={300}
                            tooltip="Enter the remaining balance on your mortgage"
                            onError={(e) => myError("HomeMortgage", null, e)}
                        />
                        {/* <InputPercentage
                            label="Home Mortgage Rate"
                            percent={form.MortgageRate}
                            name="MortgageRate"
                            onChange={onChange_t}
                            width={300}
                            tooltip="Enter the mortgage rate"
                            onError={(e) => myError("MortgageRate", null, e)}
                        /> */}
                        <InputMoney
                            xlabel="Home Mortgage Payment"
                            money={form.MortgagePayment}
                            name="MortgagePayment"
                            tooltip="Enter the mortgage payment"
                            onChange={onChange_t}
                            width={300}


                            onError={(e) => myError("MortgagePayment", null, e)}
                        />
                    </>
                )}
            </Stack>
        </Box>

    )
}







export const QuickStart = ({ open, onClose }) => {
    const [errors, setErrors] = useState({})
    const [errmsg, setErrmsg] = useState("")
    const [deleted, setDeleted] = useState(false)
    const [form, setForm] = useState({ ...defAll })



    const putRequest = async (runScenario) => {
        // let url = AccountUrl_put(
        //     clientJson,
        //     "account",
        //     form.DataSet[client].Name,
        //     form.DataSet[client].NameOrig,
        //     add
        // );
        let url = API_ClientQ
        var req = putOptions;
        form.RunScenario = runScenario
        req.body = JSON.stringify(form);
        ftchPlus(url, req)
            .then((json) => {
                console.log("update completed");

                let json2 = {}
                json2.name = form.Client.First
                json2.uuid = json.ClientUuid
                json2.spouseName = form.Spouse.First
                json2.spouseUuid = json.SpouseUuid
                json2.scenarioUuid = json.ScenarioUuid
                json2.scenarioLabel = json.ScenarioLabel
                console.log(json)
                console.log(json2)
                myClose(json2);
            })
            .catch((error) => {
                console.log(error.message);
                setErrmsg(error.message)
            });
    };

    const myClose = (json) => {
        onClose(json)
    }

    const onSubmit = () => {
        putRequest(false)
    }

    const onChange_any = (n, v) => {
        let nf = {
            ...form,
            [n]: v,
        };
        setForm(nf);
    };

    const onChange_t = (e) => {
        onChange_any(e.target.name, e.target.value);
    };

    const onError = () => {

    }
    const onChangeClient = (who, v) => {
        onChange_any(who, v)
    }

    const validation = (f) => {
    }

    const myErrorSet = (obj, i, err) => {
        let ne = errorSet(errors, setErrors, obj, i, err)
    }

    useEffect(() => {
        errorClear(errors)
        setErrmsg("")
        setForm({ ...defAll })
    }, [open])

    const onExtraButton = () => {
        putRequest(true)
    }




    return (
        <AddDialog
            clientJson={null}
            c_callback={null}
            onClose={() => myClose({})}
            open={open}
            clients={[]}
            client={""}
            label="Client QuickStart"
            accountType="QuickStart"
            onClientChange={() => { }}
            onSubmit={onSubmit}
            submitTooltip="Save the client, without running a scenario.  This allows you to make other changes before running the scenario."
            errors={errors}
            errmsg={errmsg}
            deleted={deleted}
            extraButton="Run Scenario"
            onExtraButton={onExtraButton}
            extraButtonTooltip="Run the scenario directly from here"
        >

            <Stack sx={{ mx: 20, mb: 10 }} spacing={2}>
                <Typography >
                    The Client QuickStart allows you to enter the most basic information about a client (and spouse/partner) and will create a typical set <br />
                    of accounts for each.   Default account Rates of Return and mortgage Rate are set based on FPSC guidelines, your can change them later in their Accounts.<br />
                    Enter the annualized values for Dec 31 for the year you choose, typically last year.<br />
                    There are many other types of accounts and more settings for each of these account which you can modify later by selecting them under Accounts.<br />
                </Typography>
                <Box>
                    <Stack spacing={2}>
                        <Stack sx={{ my: 8 }} direction="row" spacing={2}>
                            <InputNumber
                                label="Year"
                                name="Year"
                                number={form.Year}
                                onChange={onChange_t}
                                width={200}
                                min={2010}
                                max={new Date().getFullYear()}

                            //onError={(e) => { setDoValidation(doValidation + 1); myError("year", null, e) }}
                            />
                            <CollapseStateLabel
                                add={form.AddSpouse}
                                onClick={() => { onChange_any("AddSpouse", !form.AddSpouse) }}
                                label="Spouse"
                            />
                        </Stack>
                        <InputNumber
                            label="Retire Age"
                            name="RetireAge"
                            width={200}
                            number={form.RetireAge}
                            onChange={onChange_t}
                            min={30}
                            max={80}
                            onError={(e) => myErrorSet("retireAge", null, e)}
                        />

                    </Stack>
                </Box>
                <Stack direction="row" spacing={20}>
                    <QuickClient
                        open={open}
                        name="Client"
                        form={form.Client}
                        onChange={(c) => (onChangeClient("Client", c))}
                        errors={errors}
                        onError={(e) => myErrorSet("client", null, e)}

                    />
                    {form.AddSpouse && (
                        < QuickClient
                            open={open}
                            name="Spouse"
                            form={form.Spouse}
                            onChange={(c) => (onChangeClient("Spouse", c))}
                            errors={errors}
                            onError={(e) => myErrorSet("spouse", null, e)}

                        />
                    )}
                </Stack>


            </Stack>
        </AddDialog>

    )

}